import * as React from 'react';
import styled from 'styled-components/macro';
import { theme } from 'lib/style';
import { Modal } from 'lib/components';
import { PageLayoutListItem } from '../PageLayoutListItem';
import socialLayout from 'assets/images/landingPage/layoutSocialAndCtaReach.svg';
import mediaFocusLayout from 'assets/images/landingPage/mediaFocusLayout.svg';
import standardLayout from 'assets/images/landingPage/standardLayout.svg';
import digitalPresence from 'assets/images/landingPage/digitalPresenceLayout.svg';
import brandCtaLayout from 'assets/images/landingPage/brandAndCTAReachLayout.svg';
import mediaImageLayout from 'assets/images/landingPage/mediaImageLayout.svg';
import { useLandingPageBuilderContext } from 'app/pages/design/landingPageBuilder/context';
import { getLayoutForLayoutType } from '../Constants';
import { Button } from 'react-covideo-common';
import { IoMdClose } from 'react-icons/io';
import { useLogoUrl } from 'lib/hooks/useLogoUrl';
import { useTranslation } from 'react-i18next';
interface Props {
  onClose: (params?: any) => void;
  onContinueButtonClick: (params?: any) => void;
  type: 'add' | 'edit';
  selectedLayoutName?: string;
}

interface RowProps {
  justifyContent?: string;
  maxWidth?: string;
  marginBottom?: number;
}

const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
`;

const Row = styled.section<RowProps>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  align-items: center;
  justify-content: ${props =>
    props.justifyContent ? props.justifyContent : 'flex-start'};
  max-width: ${props => (props.maxWidth ? props.maxWidth : '100%')};
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : 16)}px;
  &:last-of-type {
    margin-bottom: 0;
  }
  button {
    margin-left: 12px;
  }
`;

const Title = styled.h2`
  margin: 0;
  padding: 0;

  font-weight: 700;
  font-size: 18px;
  color: ${theme.palette.coal};
`;

const CloseIconWrap = styled.div`
  display: flex;
  height: 24px;
  width: 24px;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`;

const getUserInfoFromPreviousLayout = (oldLayoutData: any) => {
  const data = oldLayoutData;
  let infoString = '';
  for (let key in data) {
    const section = data[key];
    if (section.sectionType === 1) {
      let childSections = section.childSections;
      for (let i = 0; i < childSections.length; i++) {
        let childSection = childSections[i];
        if (
          childSection.sectionType === 5 &&
          childSection.isUserContactInfo === true
        ) {
          infoString = data[key]['childSections'][i].textContent;
        }
      }
    }
    if (section.sectionType === 5 && section.isUserContactInfo) {
      infoString = data[key].textContent;
    }
  }

  return infoString;
};
export const ModalLandingPageDesignAddOrEdit = (props: Props) => {
  const {
    selectedLayout,
    setSelectedLayout,
    setSelectedLayoutData,
    selectedLayoutData,
    defaultCta,
    defaultSocialLinks,
    userProfile,
  } = useLandingPageBuilderContext();
  const { t } = useTranslation();
  const { logoUrl } = useLogoUrl();
  const { onClose, onContinueButtonClick } = props;
  const title = t('Choose Layout');
  const buttonText = t('Continue');

  React.useEffect(() => {}, []);

  const getUserInfoString = () => {
    if (!userProfile) {
      return '';
    }

    const firstName = userProfile?.firstName || '';
    const lastName = userProfile?.lastName || '';
    const email = userProfile?.email || '';
    const phone1 = userProfile?.phone1 ? userProfile.phone1.trim() : '';
    const phone2 = userProfile?.phone2 ? userProfile.phone2.trim() : '';
    const department = userProfile?.Dept || '';

    let contactString = '';
    const name = firstName + ' ' + lastName;
    if (name && name.trim() != '') {
      contactString += name + ' | ';
    }

    const emailAndContact = email + (phone1 !== '' ? ' ' + phone1 : '');
    if (emailAndContact && emailAndContact != '') {
      contactString += emailAndContact + ' | ';
    }

    const deptAndContact = (phone2 ? phone2 + ' ' : '') + department;
    if (deptAndContact && deptAndContact != '') {
      contactString += deptAndContact;
    }

    return contactString;
  };

  const onLayoutSelect = (e: any) => {
    let currentLayoutData = { ...selectedLayoutData };
    let userInfo = '';
    if (currentLayoutData) {
      userInfo = getUserInfoFromPreviousLayout(currentLayoutData);
    }

    if (userInfo === '') {
      userInfo = getUserInfoString();
    }
    let selectedLayoutName1 = e.target.getAttribute('data-layout-name');
    setSelectedLayout(selectedLayoutName1);
    setSelectedLayoutData(
      getLayoutForLayoutType(
        logoUrl,
        selectedLayoutName1,
        defaultCta,
        defaultSocialLinks
      )
    );
  };

  return (
    <Modal>
      <Content>
        <Row justifyContent={'space-between'}>
          <Title>{title}</Title>
          <CloseIconWrap>
            <IoMdClose
              size={24}
              onClick={onClose}
              color={theme.palette.midGrey}
            />
          </CloseIconWrap>
        </Row>
        <Row justifyContent={'space-between'}>
          <PageLayoutListItem
            isSelected={selectedLayout == 'standard'}
            layoutName={'standard'}
            layoutImageSource={standardLayout}
            onLayoutSelect={onLayoutSelect}
            selectedLayoutName={selectedLayout}
          />
          <PageLayoutListItem
            isSelected={selectedLayout == 'digitalPresence'}
            layoutName={'digitalPresence'}
            layoutImageSource={digitalPresence}
            onLayoutSelect={onLayoutSelect}
            selectedLayoutName={selectedLayout}
          />
          <PageLayoutListItem
            isSelected={selectedLayout == 'brand'}
            layoutName={'brand'}
            layoutImageSource={brandCtaLayout}
            onLayoutSelect={onLayoutSelect}
            selectedLayoutName={selectedLayout}
          />
        </Row>
        <Row>
          <PageLayoutListItem
            isSelected={selectedLayout == 'social'}
            layoutName={'social'}
            layoutImageSource={socialLayout}
            onLayoutSelect={onLayoutSelect}
            selectedLayoutName={selectedLayout}
          />
          <PageLayoutListItem
            isSelected={selectedLayout == 'mediaFocus'}
            layoutName={'mediaFocus'}
            layoutImageSource={mediaFocusLayout}
            onLayoutSelect={onLayoutSelect}
            selectedLayoutName={selectedLayout}
          />
          <PageLayoutListItem
            isSelected={selectedLayout == 'mediaImage'}
            layoutName={'mediaImage'}
            layoutImageSource={mediaImageLayout}
            onLayoutSelect={onLayoutSelect}
            selectedLayoutName={selectedLayout}
          />
        </Row>

        <Row justifyContent={'flex-end'}>
          <Button
            text={buttonText}
            disabled={selectedLayout == ''}
            onClick={() => {
              onContinueButtonClick();
            }}
          />
        </Row>
      </Content>
    </Modal>
  );
};
